import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServies";
import AddMrvForm from "./AddMrvForm";
import Swal from "sweetalert2";

const TransferOrder = ({ onSuccess }) => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);
  const [mrv, setMrv] = useState([]);
  const [selectedMrv, setSelectedMrv] = useState("");
  const [run, setRun] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [partOptions, setPartOptions] = useState([]);

  const [items, setItems] = useState([
    {
      name: "",
      id: "",
      description: "",
      transferQty: 0,
      approvedTransfer: 0,
      recived: 0,
      damageQty: 0,
      unit: "",
      error: "",
      assetOptions: [],
      hasAssets: false,
    },
  ]);

  // ➕ Add new item
  const handleAddItem = (e) => {
    e.preventDefault();

    const lastItem = items[items.length - 1];

    if (
      !lastItem ||
      !lastItem.id ||
      !lastItem.name ||
      lastItem.error ||                 // ✅ block if error exists
      lastItem.recived === "" ||        // ✅ empty
      lastItem.recived === 0            // ✅ zero not allowed
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Item",
        text: "Please fix errors and enter valid Received Qty before adding new item.",
      });
      return;
    }

    setItems((prev) => [
      ...prev,
      {
        name: "",
        id: "",
        description: "",
        transferQty: 0,
        approvedTransfer: 0,
        recived: 0,
        damageQty: 0,
        unit: "",
        error: "",
        assetOptions: [],
        hasAssets: false,
      },
    ]);
  };

  // 🔹 Handle qty & damage changes
  const handleItemChange = (index, field, value) => {
    const updated = [...items];

    const numericValue =
      field === "recived"
        ? value === ""
          ? ""
          : parseFloat(value)
        : value;

    updated[index][field] = numericValue;
    updated[index].error = "";

    if (field === "recived") {

      if (numericValue === "" || numericValue === 0) {
        updated[index].error = "Received Qty must be greater than 0";
      }

      else if (
        Number(numericValue) !==
        Number(updated[index].approvedTransfer)
      ) {
        updated[index].error =
          "Received Qty must be equal to Approved Qty";
      }
    }

    setItems(updated);
  };

  // 🔹 Handle part select
  const handlePartSelect = (index, selectedOption) => {
    if (!selectedOption) return;

    const isDuplicate = items.some((item) => item.id === selectedOption.value);
    if (isDuplicate) {
      Swal.fire({
        icon: "error",
        title: "Duplicate Item",
        text: "This item has already been added.",
      });
      return;
    }

    const hasAssets = Array.isArray(selectedOption.assets) && selectedOption.assets.length > 0;

    const updated = [...items];
    updated[index] = {
      ...updated[index],
      id: selectedOption.value,
      name: selectedOption.label,
      transferQty: selectedOption.transferQty,
      description: selectedOption.description,
      unit: selectedOption.unit,
      approvedTransfer: selectedOption.approvedTransfer,
      hasAssets,
      assetOptions: hasAssets
        ? selectedOption.assets.map((a) => ({
          value: a._id,
          label: `${a.serialNumber || "N/A"} | ${a.model || "N/A"}`,
        }))
        : [],
      recived: hasAssets
        ? selectedOption.assets.length // ✅ number of assets = received qty
        : 0,
      damageQty: 0,
    };

    setItems(updated);
  };


  // 🗑 Remove item
  const handleRemoveItem = (e, index) => {
    e.preventDefault();
    setItems((prev) => prev.filter((_, i) => i !== index));
  };

  // 🚀 Submit handler
  const handleSubmit = (e) => {
    e.preventDefault();

    // ✅ Check validation errors
    const hasError = items.some(item => item.error);

    if (hasError) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please fix errors before submitting"
      });
      return;
    }

    const requestData = { mrvId: selectedMrv, items };
    console.log("Submitting:", requestData);

    setIsSubmitting(true);

    RequestServies.submitTransferMrv(requestData)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Transfer submitted successfully.",
        });

        setItems([
          {
            name: "",
            id: "",
            description: "",
            transferQty: 0,
            approvedTransfer: 0,
            recived: 0,
            damageQty: 0,
            unit: "",
            error: "",
            assetOptions: [],
            hasAssets: false,
          },
        ]);

        setRun((r) => r + 1);
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: "Error submitting transfer.",
        });
      })
      .finally(() => setIsSubmitting(false));
  };

  // 📦 Fetch transfered items (includes assets)
  useEffect(() => {
    const status = "approved";
    RequestServies.getTransferedItem(selectedStore, status)
      .then((res) => {
        const options = res.data.data.map((part) => ({
          value: part._id, // TransferItem ID
          label: part.inventory.masterItem.partNo,
          transferQty: part.transferQty,
          description: part.inventory.masterItem.description,
          approvedTransfer: part.approveQty,
          unit: part.inventory.masterItem.unit?.name,
          assets: part.assets || [], // ✅ directly use assets
        }));
        setPartOptions(options);
      })
      .catch((error) => console.error(error));
  }, [selectedStore, run]);

  // 🧾 Fetch MRV list
  useEffect(() => {
    RequestServies.getMtn(selectedStore)
      .then((res) => {
        setMrv(res?.data?.data || []);
        setSelectedMrv(res?.data?.data?.[0]?._id || "");
      })
      .catch((err) => console.error(err));
  }, [selectedStore, run]);

  const hasError = items.some(item => item.error);

  return (
    <>
      <AddMrvForm
        show={isModelOpen}
        handleClose={() => setIsModelOpen(false)}
        store={stores}
        onSuccess={() => setRun((prev) => prev + 1)}
      />

      <div className="row">
        <div className="col-xl-12">
          {/* Filter Section */}
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to="#"
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    {/* Store Dropdown */}
                    <div className="col-xl-4">
                      <label>Select Store</label>

                      <Select
                        className="mb-3"
                        options={stores.map((store) => ({
                          value: store._id,
                          label: store.name,
                        }))}
                        value={
                          stores
                            .map((store) => ({
                              value: store._id,
                              label: store.name,
                            }))
                            .find((opt) => opt.value === selectedStore) || null
                        }
                        onChange={(selected) =>
                          setSelectedStore(selected ? selected.value : "")
                        }
                        placeholder="Search Store..."
                        noOptionsMessage={() => "No stores found"}
                        isSearchable
                      />
                    </div>

                    {/* MTN / MRV Dropdown */}
                    <div className="col-xl-4">
                      <label>Select MTN No.</label>

                      <Select
                        className="mb-3"
                        options={
                          mrv.length > 0
                            ? mrv.map((item) => ({
                              value: item._id,
                              label: item.mrvNo,
                            }))
                            : []
                        }
                        value={
                          mrv
                            .map((item) => ({
                              value: item._id,
                              label: item.mrvNo,
                            }))
                            .find((opt) => opt.value === selectedMrv) || null
                        }
                        onChange={(selected) =>
                          setSelectedMrv(selected ? selected.value : "")
                        }
                        placeholder="Search MTN No..."
                        noOptionsMessage={() => "No records found"}
                        isSearchable
                      />
                    </div>

                    <div className="col-xl-4">
                      <button
                        className="btn btn-sm btn-primary mt-4 w-100"
                        onClick={() => setIsModelOpen(true)}
                      >
                        Generate New MTN No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>

          {/* MRV Items Section */}
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa">
                <i className="fa fa-plus me-2"></i>Add MRV Item
              </div>
              <div className="tools">
                <Link
                  to="#"
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>

            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <form>
                      {items.map((item, index) => (
                        <div key={index} className="row align-items-center">
                          {/* Part Number */}
                          <div className="form-group mb-2 col-md-2">
                            <label>Part Number</label>
                            <Select
                              options={partOptions}
                              onChange={(opt) => handlePartSelect(index, opt)}
                              placeholder="Select Part"
                              menuPortalTarget={document.body}
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  height: 14,
                                }),
                              }}
                            />
                          </div>

                          {/* Description */}
                          <div className="form-group mb-2 col-md-2">
                            <label>Description</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={item.description}
                              readOnly
                            />
                          </div>

                          {/* Assets */}
                          <div className="form-group mb-2 col-md-2">
                            <label>Asset(s)</label>
                            <Select
                              options={item.assetOptions}
                              value={item.assetOptions}
                              isMulti
                              isDisabled
                              placeholder={
                                item.hasAssets
                                  ? "Associated Assets"
                                  : "No Assets Linked"
                              }
                              menuPortalTarget={document.body}
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  height: 14,
                                }),
                              }}
                            />
                          </div>

                          {/* Approved Qty */}
                          <div className="form-group mb-2 col-md-2">
                            <label>
                              {item.unit
                                ? `Approved Qty (${item.unit})`
                                : "Approved Qty"}
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              className="form-control form-control-sm"
                              value={item.approvedTransfer}
                              readOnly
                            />
                          </div>

                          {/* Received Qty */}
                          <div className="form-group mb-2 col-md-2">
                            <label>
                              {item.unit
                                ? `Received Qty (${item.unit})`
                                : "Received Qty"}
                            </label>

                            <input
                              type="number"
                              className="form-control form-control-sm"
                              value={item.recived === "" ? "" : item.recived}
                              readOnly={item.hasAssets}
                              onFocus={(e) => e.target.select()}
                              onChange={(e) =>
                                !item.hasAssets &&
                                handleItemChange(index, "recived", e.target.value)
                              }
                            />

                            {/* ✅ ERROR DISPLAY */}
                            <div style={{ minHeight: "18px" }}>
                              <p className="text-danger mb-0">{item.error}</p>
                            </div>
                          </div>



                          {/* Remove */}
                          <div className="form-group mb-2 col-md-1">
                            <button
                              className="btn btn-danger btn-xs sharp mt-1"
                              onClick={(e) => handleRemoveItem(e, index)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      ))}

                      <div className="row mt-3">
                        <div className="col-md-2">
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={handleAddItem}
                          >
                            Add Item
                          </button>
                        </div>
                        <div className="col-md-2">
                          <button
                            type="submit"
                            className="btn btn-sm btn-primary"
                            onClick={handleSubmit}
                            disabled={isSubmitting || hasError}
                          >
                            {isSubmitting ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransferOrder;
